export default function ($rootScope, $location, $http, $window, AuthenticationService) {

    $rootScope.globals = GetData();

    if($rootScope.globals.Token){
        $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.Token;
    }

    $rootScope.$on('$locationChangeStart', function (event, next, current) {
        // redirect to login page if not logged in and trying to access a restricted page

        if (['/dashboard'].indexOf($location.path()) !== -1) {
            event.preventDefault();
            $location.path('/account');
        }

        let token = $location.search().t;
        if(token){
            AuthenticationService.SetCredentials(token, function(){
                $location.search('t', null);
                Cookies.set('loading_path', $location.path());
                $location.path('loading');
            });

            return false;
        }

        let restrictedPage = ['/login', '/register', '/recovery', '/promo', '/request-promo'].indexOf($location.path()) === -1;

        let loggedIn = $rootScope.globals.currentUser;
        if (restrictedPage && !loggedIn) {
            $location.path('/login');
        }

    })
};


/** WEBPACK FOOTER **
 ** ./js/run/login.js
 **/